import { HierarchicalTopic } from 'src/actions/topics/topicsResource';

export function nameWithAncestry(topic: HierarchicalTopic): string {
  return topic.ancestralNames.join(' > ');
}
